import { TagCombobox } from './ds';
import { useTags } from '../hooks/useTags.js';
import { filterTagSuggestions } from '../lib/tagLabel.js';

/**
 * The one shared free-text tag control for every lead-intake point (TRACK-B-1b §3.1).
 * Thin by construction: no fetching layer of its own beyond the cached directory.
 * `value` is the LABEL TEXT, not a tag id — the tag is resolved (or created)
 * server-side, on submit.
 *
 * An empty directory is the PRIMARY create scenario, so the control is never disabled
 * by directory state and never shows «Нет тегов»: `disabled` comes from the host alone,
 * and a still-loading directory simply fills its suggestions in later.
 */
export const TagPicker = ({ value, onChange, onCommit, placeholder = 'Тег', disabled = false, compact = false }) => {
    const { data: tags = [] } = useTags();
    return (
        <TagCombobox
            value={value}
            onChange={onChange}
            onCommit={onCommit}
            suggestions={filterTagSuggestions(tags, value)}
            placeholder={placeholder}
            disabled={disabled}
            compact={compact}
        />
    );
};
